export default __webpack_public_path__ + "aaae6a8.png";